import { get_scroll_bar_width, get_lang, write_style } from "@/utils/util";
import Vue from "vue";

Vue.config.productionTip = false;
const eventCenter = new Vue();

const $P = {
  isLatin: document.body.classList.contains("latin"),
  isRtl: document.body.classList.contains("rtl"),
  __EVENT_CENTER: eventCenter,
  $emit: (...args) => {
    eventCenter.$emit(...args);
  },
  $on: (...args) => eventCenter.$on(...args),
  $once: (...args) => eventCenter.$once(...args),
  $off: (...args) => eventCenter.$off(...args),
};

Vue.prototype.$P = $P;

window.__supportWebp =
  0 ==
  document
    .createElement("canvas")
    .toDataURL("image/webp")
    .indexOf("data:image/webp");

window.onpopstate = () => {
  $P.$emit("popstate-change");
};

//  设置当前语言
const lang = get_lang();
document.body.classList.add(lang);
$P.lang = lang;
//  缅甸语
$P.my = lang === "my";
//  尼泊尔语
$P.ne = lang === "ne";

//  判断是否是IE11
const isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
isIE11 && document.body.classList.add("ie11");
$P.isIE11 = isIE11;

//  判断是否是rtl布局
const isRtl = getComputedStyle(document.body).direction === "rtl";
isRtl && document.body.classList.add("rtl");
$P.isRtl = isRtl;

setTimeout(() => {
  window.scrollBarWidth = get_scroll_bar_width();
  write_style(
    "scrollBars",
    `body{--scrollBarWidth:${window.scrollBarWidth}px}

    ${
      $P.isIE11
        ? `body.disabled-scroll{padding-right:${window.scrollBarWidth}px}`
        : ""
    }
    ${
      $('html[dir="rtl"]').length
        ? `.nano .nano-content{left:-${window.scrollBarWidth}px;right:0 !important;}`
        : ""
    }
    `
  );
}, 100);

//  判断缅甸语字体转换
$P.uni2zg = (text) => {
  return $P.my && $("body.zawgyi").length ? window.uni2zg(text) : text;
};



//
//  禁止在图片上右键
document.body.addEventListener("contextmenu", (ev) => {
  const unAllowElements = [
    ".v-background",
    ".viewer-img",
    ".v-full-screen-paint",
    ".v-float-image",
    ".image-box",
    ".paint-box",
    ".picture-wall-card",
  ];
  const el = ev.target;

  for (let i = 0; i < unAllowElements.length; i++) {
    if (
      el.closest(unAllowElements[i]) ||
      el.classList.contains(unAllowElements[i])
    ) {
      ev.stopPropagation();
      ev.preventDefault();
      return false;
    }
  }
});
